import { createFileRoute } from '@tanstack/react-router';

import { getShowDataOptions } from 'hooks/data/useShowData';

import { AttendView } from 'views/AttendView';

export const Route = createFileRoute('/_auth/_layout/attend/')({
  component: AttendView,
  staticData: {
    title: 'Attend',
  },
  loader: async ({ context: { queryClient } }) => {
    return queryClient.ensureQueryData(getShowDataOptions());
  },
});
